export default __webpack_public_path__ + "static/preview@2x-f3b46b7ef3f4bee750bb7f96291d84b9.png";